export default __webpack_public_path__ + "static/media/844.39f8f6eb.png";